import { render, staticRenderFns } from "./SelectCoverage.vue?vue&type=template&id=77ed1224"
import script from "./SelectCoverage.vue?vue&type=script&lang=js"
export * from "./SelectCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports